import axios from 'axios'
import { createWithEqualityFn } from 'zustand/traditional'

interface ProductionStore {
	productLines: any[]
	productCategories: any[]
	productProperties: any[]
	getProductLines: () => Promise<{ success: boolean; data: any }>
	getProductCategories: (productLineId: number) => Promise<{ success: boolean; data: any }>
	getProperties: (productLineId: number) => Promise<{ success: boolean; data: any }>
	submit: (data: any) => Promise<{ success: boolean; data: any }>
	clearState: () => void
}

export const API_SLUG = 'suppliers/production'

export const useProductionStore = createWithEqualityFn<ProductionStore>(
	set => ({
		productLines: [],
		productCategories: [],
		productProperties: [],
		getProductLines: async () => {
			return axios
				.get(`${API_SLUG}/product-lines`)
				.then(res => {
					set({ productLines: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		getProductCategories: async (productLineId: number) => {
			return axios
				.get(`${API_SLUG}/product-lines/${productLineId}`)
				.then(res => {
					set({ productCategories: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		getProperties: async (productLineId: number) => {
			return axios
				.get(`${API_SLUG}/product-lines/${productLineId}/properties`)
				.then(res => {
					set({ productProperties: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		submit: async (data: any) => {
			const formData = new FormData()
			Object.keys(data).forEach(key => {
				if (key === 'minimumOrder' || key === 'productLineId') {
					formData.append(key, data[key])
				} else if (
					[
						'products',
						'options',
						'accessories',
						'thicknesses',
						'outerMaterials',
						'innerMaterials',
						'printingOptions',
						'formings',
					].includes(key)
				) {
					if (data[key].length === 0) {
						formData.append(`${key}[]`, '')
					} else {
						data[key].forEach((item: any) => {
							formData.append(`${key}[]`, item)
						})
					}
				}
			})

			return axios
				.post(`${API_SLUG}`, formData)
				.then(res => {
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		clearState: () =>
			set({
				productLines: [],
				productCategories: [],
				productProperties: [],
			}),
	}),
	Object.is
)
